export enum ClassTabItems {
  ACTIVITIES = 'activities',
  AGENDA = 'agenda',
  ATTENDANCE = 'attendance',
}
